/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-restricted-imports */
import type { ReactNode } from 'react';
import React, { useEffect, useState } from 'react';
import type { ContentService, ContentChangeListener } from '@oneaudi/content-service';
import type { AudiFootnoteRefernceServiceScopeManagerInterfaceV3 } from '@oneaudi/footnote-reference-service';
// eslint-disable-next-line
import { VueFormatterFeatureServiceInterfaceV1 } from '@oneaudi/vue-formatter-service/lib/cjs/v1/vue-formatter-feature-service';
import type { LocaleServiceV1 } from '@volkswagen-onehub/locale-service';
import { ContentContext } from './ContentContext';
import normalizeContent from './ContentMapping';

export const ContentContextProvider: React.FC<{
  featureAppId: string;
  children?: ReactNode;
  contentService: ContentService;
  footnoteReferenceService: AudiFootnoteRefernceServiceScopeManagerInterfaceV3;
  vueFormatterService: VueFormatterFeatureServiceInterfaceV1;
  localeService: LocaleServiceV1;
  loggerService: any;
  initialContent?: any;
}> = ({
  featureAppId,
  contentService,
  children,
  vueFormatterService,
  footnoteReferenceService,
  localeService,
  loggerService,
  initialContent,
}) => {
  const [rawContent, setRawContent] = useState<any>(initialContent ?? contentService.getContent());
  const content = normalizeContent(rawContent);

  useEffect(() => {
    const listener: ContentChangeListener = () => {
      setRawContent(contentService.getContent());
    };

    contentService.onContentChange(listener);
    return () => {
      contentService.removeOnContentChange(listener);
    };
  }, [contentService]);

  return (
    <ContentContext.Provider
      value={{
        featureAppId,
        content,
        footnoteReferenceService,
        vueFormatterService,
        localeService,
        loggerService,
      }}
    >
      {children}
    </ContentContext.Provider>
  );
};

ContentContextProvider.displayName = 'ContentContextProvider';
